import { workspaceApi } from './workspaceApi';
import { Promotion, SystemSettings } from '../types';
import { WorkspaceScope } from '../types/workspace';

interface PublicPromotionResult {
  promotion: Promotion;
  settings: SystemSettings | null;
  scope: WorkspaceScope;
}

// StrictMode의 효과 재실행도 진행 중인 같은 조회를 공유하고, 완료 결과는 캐시하지 않는다.
const pending = new Map<string, Promise<PublicPromotionResult>>();
export function loadPublicPromotion(identifier: string): Promise<PublicPromotionResult> {
  const existing = pending.get(identifier);
  if (existing) return existing;
  const request = workspaceApi<PublicPromotionResult>('public', { mode: 'public', workspaceId: '', accountCode: '' }, { identifier })
    .finally(() => { if (pending.get(identifier) === request) pending.delete(identifier); });
  pending.set(identifier, request);
  return request;
}
